export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/comments/get/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/comments',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/comments',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/comments/${id}`,
      data: payload,
    });
  },
});
